import BusinessCharityContact from 'components/contacts/BusinessCharityContact';
import React from 'react';

function BusinessOrCharityContactPage() {
  return (
    <div className="leftContent">
      <BusinessCharityContact />
    </div>
  );
}

export default BusinessOrCharityContactPage;
